import styled from 'styled-components'
import { maxWidth } from '@/assets/styles/mixins.css'
import vars from '@/assets/styles/vars'

const Certificate = styled.div`
  display: flex;
  justify-content: center;
  padding: 28px 40px;
  background: var(--color-bg-accent);
  box-shadow: 0 0 0 1px var(--color-border);

  ${maxWidth(vars.breakpoints.tablet)`
    padding: 24px 30px;
  `}
`

Certificate.Image = styled.div`
  position: relative;
  height: 220px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.12);

  img {
    width: auto;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
  }

  ${maxWidth(vars.breakpoints.tablet)`
    height: 194px;
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    height: 158px;
  `}
`

export default Certificate
